import React from 'react';
import { Row, Col, DropdownButton, MenuItem } from 'react-bootstrap';
import Sound from 'react-sound';
import audio_play from '../static/audio_play.svg';
import img_display from '../static/img_display.svg';
import q_correct from '../static/q_gray.png';
import q_wrong from '../static/q_cyan.png';

function createPatternTable(data) {
  return data.map((pattern, index) => (
    <Row className='qna_separation pattern' key={'pattern_' + index}>
      <Col className='day_detail_qna' md={10} mdOffset={1}>
        <Row className='pattern'>
          <Col xs={12}>
            <span className='pattern_eng'>{pattern.en_us}</span>
            <span className='pattern_jp'>{pattern.ja_jp}</span>
          </Col>
        </Row>
      </Col>
    </Row>
  ));
}

const PatternDropdown = selected => {
  return (
    <div>
      <div>{selected ? selected : 'Select Pattern..'}</div>
      <div>
        <i className='glyphicon glyphicon-menu-down' />
      </div>
    </div>
  );
};

export const Pattern = ({ dataSet, handler }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className='day_detail'>
          <Row className='day_detail_title'>
            <Col xs={12} md={10} mdOffset={1}>
              <span>{dataSet.topic_name}</span>
            </Col>
          </Row>
          <div className='dy_ct'>
            <div className={'pattern_category ' + (dataSet.selected && 'y')}>
              <DropdownButton
                id='pattern_pick'
                noCaret
                onSelect={handler}
                title={PatternDropdown(dataSet.selected)}
              >
                {dataSet.patterns.map((pattern, i) => (
                  <MenuItem eventKey={i} key={`pattern_${i}`}>{`Pattern ${i +
                    1}`}</MenuItem>
                ))}
              </DropdownButton>
            </div>
            <div className='pattern_box'>
              {dataSet.exp && (
                <div className='pt_title'>
                  <span>"{dataSet.exp.en_us}"</span>
                  <span>{dataSet.exp.ja_jp}</span>
                </div>
              )}
              {dataSet.set && createPatternTable(dataSet.set)}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

function answerClick() {
  document.getElementById(this).className = 'active';
}

export const PatternQuiz = ({ dataSet }) => {
  let title_and_log = [];
  let mobile_log = [];

  title_and_log.push(
    <tr className='pattern_title' key={'pattern_quiz_title'}>
      <td colSpan={5}>
        <span className='title_1'>Pattern Topic: </span>
        <span className='title_2'> {dataSet.topic_name}</span>
      </td>
    </tr>
  );

  let filteredArray = dataSet.set.filter(
    val => val.result === true || val.result === false
  );

  filteredArray.forEach((quiz_log, i) => {
    title_and_log.push(
      <tr
        className={'log_line ' + ((i + 1) % 2 === 0 ? 'even_line' : 'odd_line')}
        key={'patter_quiz_log_' + i}
      >
        <td className='index'>{i + 1}</td>
        <td className='question'>{quiz_log.ja_jp}</td>
        <td className='user_answer'>{quiz_log.user}</td>
        <td className='answer'>
          <div className='dropdown'>
            <a
              className='bbb'
              id={'b_' + i}
              onClick={answerClick.bind(`b_${i}`)}
            >
              模範応答
            </a>
            <div className='dropdown-content'>
              <p>{quiz_log.en_us}</p>
            </div>
          </div>
        </td>
        <td style={{ color: quiz_log.result ? '#74cadf' : 'red' }}>
          {quiz_log.score}
        </td>
      </tr>
    );
    mobile_log.push(
      <tr
        className={
          ((i + 1) % 2 === 0 ? 'even_line ' : 'odd_line ') +
          (quiz_log.result ? 'correct' : 'wrong')
        }
        key={'mobile_log_' + i}
      >
        <td colSpan={2}>
          <div>{quiz_log.ja_jp}</div>
          <div>
            <div className='answer_btn'>
              <div className='dropdown'>
                <a id={'c_' + i} onClick={answerClick.bind(`c_${i}`)}>
                  <img
                    alt={`pattern_quiz_${i}`}
                    src={quiz_log.result ? q_correct : q_wrong}
                  />
                </a>
                <div className='dropdown-content'>
                  <p>{quiz_log.en_us}</p>
                </div>
              </div>
            </div>
            <div className='answer_usr'>{quiz_log.user}</div>
            <div className='score'>{quiz_log.score}</div>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <Row>
      <Col xs={12}>
        <div className='quiz_table pattern'>
          <table className='quiz regular'>
            <thead>
              <tr>
                <td className='index'>番号</td>
                <td className='question'>質問</td>
                <td className='user_answer'>回答</td>
                <td className='answer'>正解</td>
                <td className='correct'>発音スコア</td>
              </tr>
            </thead>
            <tbody>{title_and_log}</tbody>
          </table>
          <table className='quiz mobile'>
            <thead>
              <tr>
                <td className='qna'>質問 & 回答</td>
                <td className='score'>発音スコア</td>
              </tr>
              <tr className='topic_title'>
                <td colSpan={2}>
                  <span className='s1'>Pattern Topic: </span>
                  <span className='s2'> {dataSet.topic_name}</span>
                </td>
              </tr>
            </thead>
            <tbody>{mobile_log}</tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

function createDialogTable(data) {
  return data.map((dialogue, index) => (
    <Row
      key={index}
      className={'qna_separation ' + (index % 2 === 0 ? 'odd' : 'even')}
    >
      <Col className='day_detail_qna' md={10} mdOffset={1}>
        {/* 여기서 초기 기획과 다르게 디비구조와 api가 짜져있어서 코드를 쪼금 더럽게 짬  */}
        <Row className={index % 2 === 0 ? 'user_part' : 'musio_part'}>
          <Col xs={12}>
            <span>{dialogue.en_us}</span>
            <span>{dialogue.ja_jp}</span>
          </Col>
        </Row>
        {index % 2 === 0 ? (
          <Row>
            <Col xs={1} xsOffset={6} className='vertical_bar2' />
          </Row>
        ) : null}
      </Col>
    </Row>
  ));
}

export const Dialogue = ({ dataSet }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className='day_detail'>
          <Row className='day_detail_title'>
            <Col xs={12} md={10} mdOffset={1}>
              <span>{dataSet.topic_name}</span>
            </Col>
          </Row>
          <div className='dy_ct'>{createDialogTable(dataSet.set)}</div>
        </div>
      </Col>
    </Row>
  );
};

export const DialogueQuiz = ({ dataSet }) => {
  let topic_and_log = [];
  let mobile_log = [];

  topic_and_log.push(
    <tr className='dialogue_topic' key={'dialogue_quiz_topic'}>
      <td colSpan={5}>
        <span className='title_1'>Topic: </span>
        <span className='title_2'> {dataSet.topic_name}</span>
      </td>
    </tr>
  );

  let filteredArray = dataSet.set.filter(
    val => val.result === true || val.result === false
  );

  filteredArray.forEach((quiz_log, i) => {
    topic_and_log.push(
      <tr
        className={'log_line ' + ((i + 1) % 2 === 0 ? 'even_line' : 'odd_line')}
        key={'dialogue_quiz_log_' + i}
      >
        <td className='index'>{i + 1}</td>
        <td className='question'>{quiz_log.ja_jp}</td>
        <td className='user_answer'>{quiz_log.user}</td>
        <td className='answer'>
          <div className='dropdown'>
            <a
              className='aaa'
              id={'a_' + i}
              onClick={answerClick.bind(`a_${i}`)}
            >
              模範応答
            </a>
            <div className='dropdown-content'>
              <p>{quiz_log.en_us}</p>
            </div>
          </div>
        </td>
        <td style={{ color: quiz_log.result ? '#74cadf' : 'red' }}>
          {quiz_log.score}
        </td>
      </tr>
    );
    mobile_log.push(
      <tr
        className={
          ((i + 1) % 2 === 0 ? 'even_line ' : 'odd_line ') +
          (quiz_log.result ? 'correct' : 'wrong')
        }
        key={'mobile_log_' + i}
      >
        <td colSpan={2}>
          <div>{quiz_log.ja_jp}</div>
          <div>
            <div className='answer_btn'>
              <div className='dropdown'>
                <a id={'d_' + i} onClick={answerClick.bind(`d_${i}`)}>
                  <img
                    alt={`pattern_quiz_${i}`}
                    src={quiz_log.result ? q_correct : q_wrong}
                  />
                </a>
                <div className='dropdown-content'>
                  <p>{quiz_log.en_us}</p>
                </div>
              </div>
            </div>
            <div className='answer_usr'>{quiz_log.user}</div>
            <div className='score'>{quiz_log.score}</div>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <Row>
      <Col xs={12}>
        <div className='quiz_table dialog'>
          <table className='quiz regular'>
            <thead>
              <tr>
                <td className='index'>番号</td>
                <td className='question'>質問</td>
                <td className='user_answer'>回答</td>
                <td className='answer'>正解</td>
                <td className='correct'>発音スコア</td>
              </tr>
            </thead>
            <tbody>{topic_and_log}</tbody>
          </table>
          <table className='quiz mobile'>
            <thead>
              <tr>
                <td className='qna'>質問 & 回答</td>
                <td className='score'>発音スコア</td>
              </tr>
              <tr className='topic_title'>
                <td colSpan={2}>
                  <span className='s1'>Topic: </span>
                  <span className='s2'> {dataSet.topic_name}</span>
                </td>
              </tr>
            </thead>
            <tbody>{mobile_log}</tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

export const Vocabulary = ({ dataSet }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className='vocab_prac'>
          <table>
            <thead>
              <tr>
                <td>英語</td>
                <td>日本語</td>
              </tr>
            </thead>
            <tbody>
              {dataSet.set.map((vocab, i) => (
                <tr key={'voca_prac_' + i}>
                  <td>{vocab.en_us}</td>
                  <td>{vocab.ja_jp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

function answerPopUp(answer, i) {
  return (
    <div className='answer_btn'>
      <div className='dropdown'>
        <a id={'e_' + i} onClick={answerClick.bind(`e_${i}`)}>
          <img alt={`voca_quiz_${i}`} src={q_wrong} />
        </a>
        <div className='dropdown-content'>
          <p>{answer}</p>
        </div>
      </div>
    </div>
  );
}

export const VocaQuiz = ({ dataSet }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className='quiz_table voca'>
          <table className='quiz'>
            <thead>
              <tr>
                <td className='index'>番号</td>
                <td className='question'>日本語</td>
                <td className='user_answer'>回答</td>
                <td className='answer'>正解</td>
                <td className='correct'>O/X</td>
              </tr>
            </thead>
            <tbody>
              {dataSet.set.map((data, index) => (
                <tr
                  className={
                    ((index + 1) % 2 === 0 ? 'even_line ' : 'odd_line ') +
                    (data.result ? 'correct' : 'wrong')
                  }
                  key={index}
                >
                  <td className='index'>{index + 1}</td>
                  <td className='question'>{data.ja_jp}</td>
                  <td className='user_answer'>
                    {!data.result && answerPopUp(data.en_us, index)}
                    {data.user}
                  </td>
                  <td className='answer'>{data.en_us}</td>
                  <td className='correct'>{data.result ? 'O' : 'X'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

function clickclick2() {
  let id = this;
  document.getElementById(id).className = 'active';
}

const choices = ['A', 'B', 'C', 'D'];

function choiceRow(choice, i, j, type, user_answer, answer, sound, handlers) {
  let { onAudioPlay, onAudioEnd } = handlers;
  let { audio, display } = choice;
  let imgTarget = 'answer-' + i + '-' + j;

  return (
    <tr
      className={'choice-row ' + (choices[j] === answer ? 'answer' : '')}
      key={'choice_' + i + '_' + j}
    >
      <td></td>
      <td className='main-td'>
        <div>
          <input
            type='radio'
            disabled
            readOnly
            checked={user_answer === choices[j] ? true : false}
          />
          <div className='choice-text'>
            <span>
              {choices[j]}. {choice.audio.text}
            </span>
          </div>
          {audio.resource && (
            <div className='sound'>
              <a
                role='button'
                name='choices'
                onClick={e => onAudioPlay(i, j, e)}
              >
                <img src={audio_play} alt='audio img' />
              </a>
              <Sound
                url={audio.resource}
                playStatus={sound.choices[j]}
                onFinishedPalying={onAudioEnd}
              />
            </div>
          )}
          {choice.display.resource && (
            <div className='dropdown'>
              <a
                className='bbb'
                id={imgTarget}
                onClick={clickclick2.bind(imgTarget)}
              >
                <img src={img_display} alt='img dropdown button' />
              </a>
              <div className='dropdown-content'>
                <p>
                  <img src={display.resource} alt={`choice${j}_img`} />
                </p>
              </div>
            </div>
          )}
        </div>
      </td>
      <td></td>
    </tr>
  );
}

function spanText(type, text) {
  return <span className={`${type}_audio_text`}>{text}</span>;
}

function divImage(type, src, i) {
  return (
    <img className={`${type}_image`} src={src} alt={`${type}_${i}_image`} />
  );
}

function divSound(type, src, i, sound, handlers) {
  return (
    <div className={`${type}_row sound`}>
      <a role='button' name={type} onClick={e => handlers.onAudioPlay(i, 0, e)}>
        <img src={audio_play} alt='audio img' />
      </a>
      <Sound
        url={src}
        playStatus={sound}
        onFinishedPalying={handlers.onAudioEnd}
      />
    </div>
  );
}

/* flow

*/
function headerRow(data, type, sound, handlers, i) {
  let { audio, display } = data;
  return (
    <div className={`${type}_row`}>
      {display.resource ? (
        <div>
          <div className={`${type}_row_1 img`}>
            {divImage(type, display.resource, i)}
            {audio.resource &&
              divSound(type, audio.resource, i, sound, handlers)}
          </div>
          {audio.text ? (
            <div>{spanText(type, audio.text)}</div>
          ) : display.text ? (
            <div>{spanText(type, display.text)}</div>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        // (
        //   audio.text?
        //   <div className={`${type}_row_2`}>
        //     {spanText(type, audio.text)}
        //   </div>:
        //   (
        //     display.text?
        //     <div className={`${type}_row_2`}>
        //       {spanText(type, display.text)}
        //     </div>
        //     :null
        //   )
        // ):
        <div className={`${type}_row_2`}>
          {audio.text && spanText(type, audio.text)}
          {audio.resource && divSound(type, audio.resource, i)}
        </div>
      )}
    </div>
  );
}

// if more quiz type is added this code needs to updated (very poor scalability)
function questionRow(quiz, i, sound, handlers) {
  let { header, answer, user_answer } = quiz;

  return (
    <tr className='question-row' key={'question+' + i}>
      <td>{i + 1}</td>
      <td className='main-td'>
        {headerRow(header.material, 'material', sound.material, handlers, i)}
        {headerRow(header.question, 'question', sound.question, handlers, i)}
      </td>
      <td>
        {answer === user_answer ? (
          <span className='correct'>correct</span>
        ) : (
          <span className='incorrect'>incorrect</span>
        )}
      </td>
    </tr>
  );
}

export const Quiz = ({ content, sound, handlers }) => {
  // let {sound} = state;
  // let dataSet = content.sets;
  // let {onAudioPlay, onAudioEnd} = handlers;
  console.log(content.sets);
  console.log(sound);
  let quizBody = [];

  content.sets.forEach((quiz, i) => {
    quizBody.push(questionRow(quiz, i, sound[i], handlers));
    quiz.body.forEach((choice, j) =>
      quizBody.push(
        choiceRow(
          choice,
          i,
          j,
          quiz.type,
          quiz.user_answer,
          quiz.answer,
          sound[i],
          handlers
        )
      )
    );
  });

  return (
    <Row>
      <Col xs={12}>
        <div className='quiz_table'>
          <table className='quiz day4'>
            <thead>
              <tr>
                <td>番号</td>
                <td className='main-td'>質問</td>
                <td>Correct</td>
              </tr>
            </thead>
            <tbody>{quizBody}</tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Day.Components.js